<div class="ui-select">
  @if (label()) {
    <label class="ui-select__label" [attr.for]="id() || null">
      {{ label() | uiLabelTranslate }}
      @if (required()) {
        <span class="ui-select__required">*</span>
      }
    </label>
  }

  @if (multiple()) {
    <div class="ui-select__multi" [class.ui-select__multi--open]="isOpen()">
      <button
        class="ui-select__control ui-select__multi-trigger"
        type="button"
        [id]="id() || null"
        [disabled]="disabled()"
        [attr.aria-expanded]="isOpen()"
        [attr.aria-label]="triggerAriaLabel()"
        aria-haspopup="listbox"
        (click)="toggleOpen()"
      >
        <span class="ui-select__multi-value" [class.ui-select__multi-value--placeholder]="!hasSelectedValues()">
          @if (hasSelectedValues()) {
            @for (selectedLabel of visibleSelectedLabels(); track selectedLabel) {
              <span class="ui-select__selected-chip">{{ selectedLabel | uiLabelTranslate }}</span>
            }
            @if (hiddenSelectedCount()) {
              <span class="ui-select__selected-chip ui-select__selected-chip--more">... +{{ hiddenSelectedCount() }}</span>
            }
          } @else {
            <span>{{ placeholder() | uiLabelTranslate }}</span>
          }
        </span>
        <span class="ui-select__chevron" aria-hidden="true"></span>
      </button>

      @if (isOpen()) {
        <div class="ui-select__menu" role="listbox" aria-multiselectable="true">
          <input
            class="ui-select__search"
            type="search"
            placeholder="Search"
            [value]="searchTerm()"
            (input)="setSearchTerm(searchControl.value)"
            (click)="$event.stopPropagation()"
            #searchControl
          />

          @for (option of filteredOptions(); track option.value) {
            <button
              class="ui-select__option"
              type="button"
              role="option"
              [disabled]="option.disabled ?? false"
              [attr.aria-selected]="values().includes(option.value)"
              (click)="toggleMultiValue(option.value)"
            >
              <span class="ui-select__checkbox" [class.ui-select__checkbox--checked]="values().includes(option.value)" aria-hidden="true"></span>
              <span>{{ option.label | uiLabelTranslate }}</span>
            </button>
          } @empty {
            <p class="ui-select__empty">No options found.</p>
          }
        </div>
      }
    </div>
  } @else {
    <select
      class="ui-select__control"
      [id]="id() || null"
      [disabled]="disabled()"
      [value]="value()"
      (change)="onValueChange(controlValue.value)"
      #controlValue
    >
      @if (!required()) {
        <option value="">{{ placeholder() | uiLabelTranslate }}</option>
      }

      @for (option of options(); track option.value) {
        <option [value]="option.value" [disabled]="option.disabled ?? false">
          {{ option.label | uiLabelTranslate }}
        </option>
      }
    </select>
  }

  @if (error()) {
    <p class="ui-select__error">{{ error() | uiLabelTranslate }}</p>
  } @else if (hint()) {
    <p class="ui-select__hint">{{ hint() | uiLabelTranslate }}</p>
  }
</div>
